import { render, staticRenderFns } from "./MdfeEnvironment.vue?vue&type=template&id=9740f6ac&scoped=true"
import script from "./MdfeEnvironment.vue?vue&type=script&lang=js"
export * from "./MdfeEnvironment.vue?vue&type=script&lang=js"
import style0 from "./MdfeEnvironment.vue?vue&type=style&index=0&id=9740f6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9740f6ac",
  null
  
)

export default component.exports